import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addcontracttype',
  templateUrl: './addcontracttype.component.html',
  styleUrls: ['./addcontracttype.component.css']
})
export class AddcontracttypeComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "ContractType";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  contracttypeColl: any = [];
  contracttypeBO: any = {};
  contracttypeid: number = 0

  contracttypeform = new FormGroup({
    contracttypeid: new FormControl(0),
    contracttypename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  @Input() ischild: boolean = false;
  @Input() ischildadd: boolean = false;
  @Input() ischildkey: number = 0
  @Output() childChanged = new EventEmitter<number>();



  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.contracttypeid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.contracttypeform.reset();
      this.fnInitializeFormGroup();

      if (this.contracttypeid > 0) {
        this.fngetContractType();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.contracttypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.contracttypeform.setValue({
      contracttypeid: 0,
      contracttypename: '',
      inactive: false
    })
  }

  //Get 
  fngetContractType() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'contracttypeid': this.contracttypeid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getContractType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.contracttypeColl = res.json().result;
            var editdata = this.contracttypeColl[0];
            this.contracttypeBO = editdata;
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.contracttypeform.valid) {
        //Check
        this.saveloading = true;

        var data = {
          'contracttypeid': this.contracttypeid,
          'contracttypename': this.contracttypeform.get('contracttypename').value,
          'inactive': this.contracttypeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckContractType(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.contracttypeform.get('contracttypeid').value > 0) {
                  //Update 
                  this.fnSetContractType(data);
                }
                else {
                  //Insert 
                  this.fnInsertContractType(data);
                }
              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;

                  this.contracttypeform.controls['contracttypename'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertContractType(data) {

    this.appService.fnInsertContractType(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {

            this.ischildkey = res.json().result[0][0].contracttypeid;
            this.ischildadd = true;


            this.toastr.success('', "The new contracttype has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.contracttypename);

            this.fnCloseForm();
          }
        }
        else {

          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetContractType(data) {

    this.appService.fnSetContractType(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The contracttype has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.contracttypeid, data.contracttypename);

            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      if (this.ischild === false) {
        this.router.navigate(['/ContractType']);
      }
      else {
        var pBO: any = {
          isadd: this.ischildadd,
          childkey: this.ischildkey,
          doctype: 'CONTRACTTYPE'
        }
        this.childChanged.emit(pBO);
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.contracttypeform.setValue({
      contracttypeid: deptBO.contracttypeid,
      contracttypename: deptBO.contracttypename,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
